<template>
  <div id="app">
    <cookie-alert :show="showCookiesModal" @save="setCookie"></cookie-alert>
    <transition name="page" mode="out-in">
      <component v-if="layout" :is="layout"></component>
    </transition>
  </div>
</template>

<script>
// Load layout components dynamically.
const requireContext = require.context('../layouts', false, /.*\.vue$/)

const layouts = requireContext.keys()
  .map(file =>
    [file.replace(/(^.\/)|(\.vue$)/g, ''), requireContext(file)]
  )
  .reduce((components, [name, component]) => {
    components[name] = component
    return components
  }, {})

import { QAjaxBar } from 'quasar-framework'
import CookieAlert from './CookieAlert'

export default {
  el: '#app',

  data: () => ({
    layout: null,
    defaultLayout: 'default',
    showCookiesModal: true
  }),
  mounted() {
    this.checkCookie()
  },
  metaInfo () {
    const { appName } = window.config

    return {
      title: appName,
      titleTemplate: `%s · ${appName}`
    }
  },

  components: {
      QAjaxBar,
    CookieAlert
  },

  methods: {
    /**
     * Set the application layout.
     *
     * @param {String} layout
     */
    setLayout (layout) {
      if (!layout || !layouts[layout]) {
        layout = this.defaultLayout
      }

      this.layout = layouts[layout]
    },
    setCookie () {
      this.$q.cookies.set('accepted_cookies', true, {
        expires: 365,
        secure: true,
        SameSite: 'None'
      })

      this.showCookiesModal = false
    },
    checkCookie () {
      if(this.$q.cookies.has('accepted_cookies')) {
        this.showCookiesModal = !this.$q.cookies.get('accepted_cookies')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/App.vue